import { render, staticRenderFns } from "./IbIdeaAvatar.vue?vue&type=template&id=0f968a90&scoped=true"
import script from "./IbIdeaAvatar.vue?vue&type=script&lang=js"
export * from "./IbIdeaAvatar.vue?vue&type=script&lang=js"
import style0 from "./IbIdeaAvatar.vue?vue&type=style&index=0&id=0f968a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f968a90",
  null
  
)

export default component.exports